import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastService } from '../../toast/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastDuration } from '../../toast/models/toast-duration.enum';

@Component({
	selector: 'app-sliding-card',
	templateUrl: './sliding-card.component.html',
	styleUrls: ['./sliding-card.component.scss']
})
export class SlidingCardComponent {
	@Input() public cardText: string;
	@Input() public isDeleteDisabled: boolean;
	@Output() public selectedCard: EventEmitter<void> = new EventEmitter();
	@Output() public editConnection: EventEmitter<void> = new EventEmitter();
	@Output() public deleteConnection: EventEmitter<void> = new EventEmitter();

	public constructor(
		private toastService: ToastService,
		private translateService: TranslateService
	) {}

	public selectCard(): void {
		this.selectedCard.emit();
	}

	public handleEditConnection(e: any): void {
		e.stopPropagation();
		this.editConnection.emit();
	}

	public handleDeleteConnection(e: any): void {
		if (this.isDeleteDisabled) {
			this.toastService.presentError(
				this.translateService.instant('connectionsModal.messages.delete'),
				ToastDuration.Fast
			);
			return;
		}

		e.stopPropagation();
		this.deleteConnection.emit();
	}
}
